import { render, staticRenderFns } from "./MenuBar.vue?vue&type=template&id=4d656bbc&scoped=true&"
import script from "./MenuBar.vue?vue&type=script&lang=js&"
export * from "./MenuBar.vue?vue&type=script&lang=js&"
import style0 from "./MenuBar.vue?vue&type=style&index=0&id=4d656bbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d656bbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib'
import { VListItem } from 'vuetify/lib'
import { VListItemTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
installComponents(component, {VList,VListItem,VListItemTitle,VMenu})
